import React from "react";
import Blocks from "editorjs-blocks-react-renderer";
import Button from "../button";
import ImageRenderer from "../imageRenderer";
const RichText = ({ data }) => {
  const { RichText } = data.RichText.data;

  return (
    <section
      className={`RichText my-10 lg:my-12 xl:p-0  prose mx-auto max-w-screen-xl xxl:max-w-screen-3xl bg-white p-5  ${
        data.TextAlignmentLeft ? "prose-p:text-left" : "prose-p:text-center"
      } ${
        data.TextAlignmentLeft
          ? "prose-h1:text-left prose-h2:text-left prose-h3:text-left prose-h4:text-left prose-h1:text-xl"
          : "prose-h1:text-center prose-h2:text-center prose-h3:text-center  prose-h4:text-center prose-h1:text-3xl lg:prose-h1:text-6xl "
      } `}
    >
      {data?.RichText?.data?.RichText ? (
        <Blocks
          data={JSON.parse(RichText)}
          renderers={{
            image: ImageRenderer,
          }}
        />
      ) : (
        ""
      )}
      <div className={data.TextAlignmentLeft ? "" : "text-center"}>
        {data.Button?.ShowButton && <Button data={data.Button} />}
      </div>
    </section>
  );
};

export default RichText;
